export const appendTooltipGlossary = (content) => {
  if (typeof content !== "string") return content;

  const glossaryRules = [
    {
      key: "SLA",
      hasTerm: /\bSLA\b/i,
      hasDefinition: /service level agreement/i,
      text: "SLA = Service Level Agreement (an agreed service-performance target, such as delivery speed or on-time completion).",
    },
    {
      key: "YoY",
      hasTerm: /\bYoY\b/i,
      hasDefinition: /year[- ]over[- ]year/i,
      text: "YoY = Year-over-Year (comparison versus the same period last year).",
    },
    {
      key: "MoM",
      hasTerm: /\bMoM\b/i,
      hasDefinition: /month[- ]over[- ]month/i,
      text: "MoM = Month-over-Month (comparison versus the immediately previous month).",
    },
    {
      key: "Margin",
      hasTerm: /\bmargin\b/i,
      hasDefinition: /profit\s*\/\s*revenue|profit margin/i,
      text: "Margin = Profit / Revenue x 100 (the percent of revenue retained after direct costs).",
    },
    {
      key: "Break-even",
      hasTerm: /break[- ]even/i,
      hasDefinition: /revenue\s*(equals|=)\s*cost|no net profit|no net loss/i,
      text: "Break-even = Revenue equals cost (no net profit and no net loss).",
    },
    {
      key: "Rate",
      hasTerm: /\brate\b/i,
      hasDefinition: /average revenue per service|unit price/i,
      text: "Rate = Average revenue per service (a proxy for realized unit pricing).",
    },
  ];

  const definitionsToAppend = glossaryRules
    .filter((rule) => rule.hasTerm.test(content) && !rule.hasDefinition.test(content))
    .map((rule) => rule.text);

  if (definitionsToAppend.length === 0) return content;

  return `${content}\n\nGlossary:\n• ${definitionsToAppend.join("\n• ")}`;
};
